module.exports = __webpack_public_path__ + "static/media/Icon_menu_consumables_white.b585a232.svg";